import { all } from 'redux-saga/effects';
import { authSagas } from './auth';
import { billingSagas } from './billing';
import { domainsSagas } from './domains';
import { emailsSagas } from './emails';
import { sitesSagas } from './sites';
import { productsSagas } from './products';
import { dnsWizardSagas } from './dnsWizard';
import { faqSagas } from './faq';
import { invoicesSagas } from './invoices';
import { asaasSagas } from './asaas';
import { preChatSagas } from './preChat';
import { formsSagas } from './forms';
import { backupSagas } from './backup';
import { securitySagas } from './security';
import { linkNaBioSagas } from './linkNaBio';
import { gatorProtectSagas } from './gatorProtect';
import { videoClassesSagas } from './videoClasses';
import { cloudflareSagas } from './cloudflare';
import { commonSagas } from './common';
import { onboardingSagas } from './onboarding';
import { homeSagas } from './home';
import { merlinSagas } from './merlin';
import { fastCheckoutSagas } from './fastcheckout';
import { vpsOciSagas } from './productDetail/vpsOci';
import { agentsFactorySagas } from './agentsFactory';
import { adsHandlerSagas } from './adsHandler';
import { referrerSagas } from './referrer';
import { supergatorSagas } from './supergator';
import { portalModalsSagas } from './portalModals';
import { advancedHostingSagas } from './advancedHosting';
import { ssoAcceptSagas } from './ssoAccept';

const sagas = [
  authSagas(),
  billingSagas(),
  domainsSagas(),
  emailsSagas(),
  sitesSagas(),
  productsSagas(),
  faqSagas(),
  dnsWizardSagas(),
  invoicesSagas(),
  asaasSagas(),
  preChatSagas(),
  formsSagas(),
  backupSagas(),
  securitySagas(),
  linkNaBioSagas(),
  gatorProtectSagas(),
  videoClassesSagas(),
  cloudflareSagas(),
  commonSagas(),
  onboardingSagas(),
  homeSagas(),
  merlinSagas(),
  fastCheckoutSagas(),
  vpsOciSagas(),
  agentsFactorySagas(),
  adsHandlerSagas(),
  referrerSagas(),
  supergatorSagas(),
  portalModalsSagas(),
  advancedHostingSagas(),
  ssoAcceptSagas(),
];

function* rootSaga() {
  yield all(sagas);
}

export default rootSaga;
